/**
 * useTenantScanSchedule — the selected tenant's scan schedule for the
 * never-scanned brief, shared by every page that shows it (Command Center,
 * Baseline Compliance, Security Center Overview) so their copy cannot drift
 * apart. Reads the existing GET /tenants/{id}/scan-settings (its Function
 * proxy requires tenant access), only while `scanScheduleQueryEnabled` holds.
 */
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { ScanScheduleState } from '@/lib/brief-helpers'
import { scanScheduleQueryEnabled, scanScheduleState } from '@/lib/scan-schedule'

export function useTenantScanSchedule(opts: Parameters<typeof scanScheduleQueryEnabled>[0]): ScanScheduleState {
  const enabled = scanScheduleQueryEnabled(opts)
  const { data } = useQuery({
    queryKey: ['tenant-scan-settings', opts.tenantId],
    queryFn: () => api.getTenantScanSettings(opts.tenantId as string),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
  // Loading, failed or disabled: 'pending', so no schedule is claimed.
  return enabled ? scanScheduleState(data) : 'pending'
}
